/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyBankAccount = {
  properties: {
    bankCode: {
      type: 'string',
      isRequired: true,
    },
    branchNumber: {
      type: 'string',
      isRequired: true,
    },
    branchDigit: {
      type: 'string',
    },
    accountNumber: {
      type: 'string',
      isRequired: true,
    },
    accountDigit: {
      type: 'string',
      isRequired: true,
    },
    status: {
      type: 'CompanyBankAccountStatus',
    },
    accountType: {
      type: 'BankAccountType',
      isRequired: true,
    },
  },
} as const;
